import { render, staticRenderFns } from "./DesignerAside.vue?vue&type=template&id=7847e5b2&scoped=true&"
import script from "./DesignerAside.vue?vue&type=script&lang=js&"
export * from "./DesignerAside.vue?vue&type=script&lang=js&"
import style0 from "./DesignerAside.vue?vue&type=style&index=0&id=7847e5b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847e5b2",
  null
  
)

export default component.exports